import App from './App';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import { hydrate } from 'react-dom';
import routes from './routes/main';

const data = window._INITIAL_DATA_;
const userData = window._USER_DATA_;

hydrate(
	<BrowserRouter>
		<App routes={routes} initialData={data} userData={userData} />
	</BrowserRouter>,
	document.getElementById('root')
);

if (module.hot) {
	module.hot.accept();
}
